import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Link } from 'react-router-dom';
const forEach = require('lodash/forEach');
const sortBy = require('lodash/sortBy');
const filter = require('lodash/filter');

const Globals = require('../../../../app/globals');
const AssignmentStore = require('../../stores/AssignmentStore');
const AssignmentActions = require('../../actions/AssignmentActions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    user: PropTypes.object.isRequired
};

const defaultProps = {};

class AdminUserAssignmentInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            assignmentStoreState: AssignmentStore.getState(),
            userIsEmulated: AdminGlobalUserStore.getState().emulated3pUserInfo.id === props.user.id
        };

        this.getDataForUserId = this.getDataForUserId.bind(this);
        this.renderSelectedUserStudentCounts = this.renderSelectedUserStudentCounts.bind(this);
        this.renderSelectedUserAssignmentDetails = this.renderSelectedUserAssignmentDetails.bind(this);

        this.unsubscribes = [
        AssignmentStore.listen(this.onStoreChange.bind(this, 'assignmentStoreState')),
        AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.getDataForUserId(this.props.user.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.user.id === prevProps.user.id) {
            return;
        }

        const user = this.props.user;
        this.getDataForUserId(user.id, () => {
            this.setState({ selectedUser: user });
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    onAdminGlobalUserStoreChange(state) {
        this.setState({
            userIsEmulated: state.emulated3pUserInfo.id === this.props.user.id
        });
    }

    getDataForUserId(userId, callback) {
        AssignmentActions.adminGetUserAssignments(uuid.v4(), { id: userId });
        AssignmentActions.adminGetStudentCountPerIntegrationType(uuid.v4(), { id: userId });
        if (!!callback) callback();
    }

    renderSelectedUserStudentCounts() {
        const user = this.props.user;

        if (!user) {
            return null;
        }

        if (!this.state.assignmentStoreState) {
            return null;
        }

        if (!this.state.assignmentStoreState.userAssignmentStudentCounts) {
            return null;
        }

        if (this.state.assignmentStoreState.userAssignmentStudentCounts.loading) {
            return ( <li>{'Loading Student Counts...'}</li> );
        }

        var studentCounts = this.state.assignmentStoreState.userAssignmentStudentCounts[user.id];
        if (!studentCounts || studentCounts.length === 0) {
            return ( <li>No Students</li> );
        }

        let elems = [];
        forEach(studentCounts, elem => {
            var integrationTitle;
            switch (elem.integrationType) {
                case Globals.integration_type.GOOGLE_CLASSROOM:
                    integrationTitle = 'Google Classroom Students';
                    break;
                case Globals.integration_type.LOCAL:
                    integrationTitle = 'Local Assignment Students';
                    break;
                case Globals.integration_type.LTI:
                    integrationTitle = 'LTI Assignment Students';
                    break;
                case Globals.integration_type.CONNECT:
                    integrationTitle = 'Connect Assignment Students';
                    break;
                case Globals.integration_type.VANTAGE:
                    integrationTitle = 'Vantage Assignment Students';
                    break;
                case 'none':
                    integrationTitle = 'Non Integration Students'; // is this possible?
                    break;
                default:
                    integrationTitle = elem.integrationType + " Assignment Students";
            }
            elems.push(
                <li key={`integration_heading_${elem.partner}_${elem.integrationType}`}>
                    <div className="user-view-student-count-row">
                        <h1 className="font-weight-bold">{`${integrationTitle}, Partner ${elem.partner}: ${elem.studentCount}`}</h1>
                    </div>
                </li>
            )
        });
        return (
            <li className="row">
                <div className="col-sm-12 user-view-student-counts">
                    <ul>{elems}</ul>
                </div>
            </li>
        )
    }

    renderSelectedUserAssignmentDetails() {
        const user = this.props.user;
        const userIsEmulated = this.state.userIsEmulated;

        if (!user) {
            return null;
        }
        if (!this.state.assignmentStoreState) {
            return null;
        }
        if (!this.state.assignmentStoreState.userAssignments) {
            return null;
        }
        if (this.state.assignmentStoreState.userAssignments.loading) {
            return ( <li>{'Loading Assignments...'}</li> );
        }

        const userAssignments = this.state.assignmentStoreState.userAssignments[user.id];

        if (!userAssignments || userAssignments.length === 0) {
            return ( <li>No Assignments</li> );
        }

        const _getIntegrationType = function(a) {
            let integrationType = 'none';
            if (a.external_data && a.external_data) {
                integrationType = a.external_data.integrationType;
            }
            return integrationType;
        };

        const adminUserElem = (
            <AccessibleIcon label="Admin user" showLabelAsTitle>
                <i className="fa fa-user-plus" aria-hidden="true" />
            </AccessibleIcon>
        );
        const emuUserElem = (
            <AccessibleIcon label="Emulated user" showLabelAsTitle>
                <i className="fa fa-user" aria-hidden="true" />
            </AccessibleIcon>
        );
        const nullUserElem = (
            <AccessibleIcon label="Unavailable user" showLabelAsTitle>
                <i className="fa fa-user-times" aria-hidden="true" />
            </AccessibleIcon>
        );
        // link for admin to enter this assignment as ensured assignment admin
        const _getAdminElem = (hash, integrationType) => {
            switch (integrationType) {
                case Globals.integration_type.GOOGLE_CLASSROOM:
                case Globals.integration_type.LOCAL:
                case Globals.integration_type.LTI: {
                    return (
                        <span>
                            {adminUserElem}
                            <Link className="margin-left-sm" to={`/assignment/${hash}/admin`} target='_blank'>
                                {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                            </Link>
                        </span>
                    );
                }
                case Globals.integration_type.CONNECT: {
                    return (
                        <span>
                            {adminUserElem}
                            <Link className="margin-left-sm" to={`/connect/report/admin/${hash}`} target="_blank">
                                {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                            </Link>
                        </span>
                    );
                }
                case Globals.integration_type.VANTAGE: {
                    return (
                        <span>
                            {adminUserElem}
                            <Link className="margin-left-sm" to={`/vantage/report/admin/${hash}`} target="_blank">
                                {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                            </Link>
                        </span>
                    );
                }
                default: {
                    return (
                        <span>
                            {nullUserElem}
                            <span className="margin-left-sm">{hash}</span>
                        </span>
                    );
                }
            }
        }

        // link for admin to enter this assignment when they are emulating a 3rd party user
        const _getEmulationElem = (hash, integrationType, roleToken) => {
            switch (integrationType) {
                case Globals.integration_type.GOOGLE_CLASSROOM:
                case Globals.integration_type.LOCAL:
                case Globals.integration_type.LTI: {
                    return (
                        <span>
                            {emuUserElem}
                            <Link className="margin-left-sm" to={`/assignment/${hash}`} target='_blank'>
                                {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                            </Link>
                        </span>
                    );
                }
                case Globals.integration_type.CONNECT: {
                    if (roleToken === Globals.users.roles.STUDENT) {
                        return (
                            <span>
                                {emuUserElem}
                                <Link className="margin-left-sm" to={`/connect/launch/${hash}`} target="_blank">
                                    {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                                </Link>
                            </span>
                        );
                    }
                    else if (roleToken === Globals.users.roles.INSTRUCTOR) {
                        return (
                            <span>
                                {emuUserElem}
                                <Link className="margin-left-sm" to={`/connect/report/instructor/${hash}`} target="_blank">
                                    {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                                </Link>
                            </span>
                        ); 
                    }
                    else {
                        return (
                            <span>
                                {nullUserElem}
                                <span className="margin-left-sm">{hash}</span>
                            </span>
                        );
                    }
                }
                case Globals.integration_type.VANTAGE: {
                    if (roleToken === Globals.users.roles.STUDENT) {
                        return (
                            <span>
                                {emuUserElem}
                                <Link className="margin-left-sm" to={`/vantage/launch/${hash}`} target="_blank">
                                    {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                                </Link>
                            </span>
                        );
                    }
                    else if (roleToken === Globals.users.roles.INSTRUCTOR) {
                        return (
                            <span>
                                {emuUserElem}
                                <Link className="margin-left-sm" to={`/vantage/report/instructor/${hash}`} target="_blank">
                                    {hash}<i className='fa fa-external-link margin-left-sm' aria-hidden="true" />
                                </Link>
                            </span>
                        );
                    }
                    else {
                        return (
                            <span>
                                {nullUserElem}
                                <span className="margin-left-sm">{hash}</span>
                            </span>
                        );
                    }
                }
                default: {
                    return (
                        <span>
                            {nullUserElem}
                            <span className="margin-left-sm">{hash}</span>
                        </span>
                    );
                }
            }
        }

        // sort assignments by integration type then partner
        const sortedAssignments = sortBy(userAssignments,function(a) {
            const integrationType = _getIntegrationType(a);
            const partner = a.owner ? a.owner.id : 0;
            return integrationType + "|" + partner;
        });

        let lastIntegrationType = null;
        let integrationTitle = '';
        let lastPartnerId = -1;
        let gapNeeded = false;
        let gapCount = 0;
        let elems = [];
        forEach(sortedAssignments, function(a) {
            const integrationType = _getIntegrationType(a);
            if (lastIntegrationType !== integrationType) {
                lastIntegrationType = integrationType;
                const count = filter(sortedAssignments,function(a) {
                    return (_getIntegrationType(a) === integrationType);
                }).length;

                switch (integrationType) {
                    case Globals.integration_type.GOOGLE_CLASSROOM:
                        integrationTitle = 'Google Classroom Assignments';
                        break;
                    case Globals.integration_type.LOCAL:
                        integrationTitle = 'Local Assignments';
                        break;
                    case Globals.integration_type.LTI:
                        integrationTitle = 'LTI Assignments';
                        break;
                    case Globals.integration_type.CONNECT:
                        integrationTitle = 'Connect Assignments';
                        break;
                    case Globals.integration_type.VANTAGE:
                        integrationTitle = 'Vantage Assignments';
                        break;
                    case 'none':
                        integrationTitle = 'Assignments with no Integration';
                        break;
                    default:
                        integrationTitle = integrationType + " Assignments";
                }

                if (gapNeeded) {
                    gapNeeded = false;
                    gapCount++;
                    elems.push( <li key={gapCount} className="user-view-assignment-row-gap"/> );
                }

                elems.push(
                    <li key={`integration_heading_${integrationType}`}>
                        <div className="user-view-assignment-row">
                            <h1 className="font-weight-bold">{`${integrationTitle} (${count})`}</h1>
                        </div>
                    </li>
                );

                elems.push(
                    <li key={`integration_heading_key_${integrationType}`}>
                        <div className="row user-view-assignment-row">
                            <div className="col-sm-3">
                                <div className="title-block">
                                    <div className="title-row">
                                        <label>{'Assignment Name:'}</label>
                                    </div>
                                    <div className="title-row">
                                        <label>{'Activity Name:'}</label>
                                    </div>
                                    <br/>
                                </div>
                            </div>
                            <div className="col-sm-2"><label>{'Template:'}</label></div>
                            <div className="col-sm-2"><label>{'Created:'}</label></div>
                            <div className="col-sm-4"><label>{'Assignment:'}</label></div>
                            <div className="col-sm-1"><label>{'Role:'}</label></div>
                        </div>
                    </li>
                );
            }

            const partnerId = a.owner ? a.owner.id : 0;
            if (lastPartnerId !== partnerId) {
                lastPartnerId = partnerId;
                const partnerName = a.owner ? ( a.owner.partner_name || a.owner.email ) : 'none';

                if (gapNeeded) {
                    gapNeeded = false;
                    gapCount++;
                    elems.push( <li key={gapCount} className="user-view-assignment-row-gap"/> );
                }

                elems.push(
                    <li key={`partner_heading_${lastIntegrationType}_${partnerId}`}>
                        <div className="user-view-assignment-row">
                            <h1 className="font-weight-bold">{`Partner ${partnerId}: ${partnerName}`}</h1>
                        </div>
                    </li>
                )

            }

            let assignmentTitle = a.name;
            if (!assignmentTitle) {
                assignmentTitle = 'Not Provided';
            }

            let activityTitle = 'Not Provided';
            if (a.activity && a.activity.meta_data && a.activity.meta_data.title) {
                activityTitle = a.activity.meta_data.title;
            }

            elems.push(
                <li key={a.hash}>
                    <div className="row user-view-assignment-row">
                        <div className="col-sm-3">
                            <div className="title-block">
                                <div className="title-row">
                                    <span>{assignmentTitle}</span>
                                </div>
                                <div className="title-row">
                                    <span>{activityTitle}</span>
                                </div>
                                <br/>
                            </div>
                        </div>
                        <div className="col-sm-2"><span>{a.templateName}</span></div>
                        <div className="col-sm-2"><span>{a.create_date}</span></div>
                        <div className="col-sm-4">
                            {(userIsEmulated) ?
                                _getEmulationElem(a.hash, integrationType, a.role_token)
                                :
                                _getAdminElem(a.hash, integrationType)
                            }
                        </div>
                        <div className="col-sm-1"><span>{a.role_token}</span></div>
                    </div>
                </li>
            );
            gapNeeded = true;
        });

        return (
            <li className="row">
                <div className="col-sm-12 user-view-assignment-list">
                    <ul>{elems}</ul>
                </div>
            </li>
        );
    }

    render() {
        return (
            <div>
                <h4>Counts</h4>
                <ul>
                    {this.renderSelectedUserStudentCounts()}
                </ul>

                <h4>Assignments</h4>
                <ul>
                    {this.renderSelectedUserAssignmentDetails()}
                </ul>
            </div>
        );
    }
}

AdminUserAssignmentInfo.propTypes = propTypes;
AdminUserAssignmentInfo.defaultProps = defaultProps;

export default AdminUserAssignmentInfo;